import Joi from 'joi';
import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Quotation } from '@/modules/quotation/quotation.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createQuotation = () => ({
  body: generateJoiValidation(Quotation.schema),
});

export const updateQuotation = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Quotation.schema, true),
});

export const getQuotation = {
  query: Joi.object().keys({
    companyId: Joi.string(),
    project: Joi.string(),
    search: Joi.string(),
    sortBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getQuotationById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteQuotationById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
